import React from "react";

interface TextAreaProps {
  label: string;
  name: string;
  value: string;
  variant?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  error?: string; // Error message prop
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  variant,
  error, // Destructure error prop
}) => {
  return (
    <div className="flex flex-col w-full">
      <label className="text-secondary-main font-medium mb-1">{label}</label>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`border rounded-md p-4 py-5 w-full focus:border-[2px] outline-none ${
          variant
            ? "!border-[rgba(var(--primary-color-rgb),0.5)]"
            : "border-themeColor"
        } ${error ? "border-red-500" : ""}`} // Apply red border if error exists
        rows={4}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}{" "}
      {/* Display error message */}
    </div>
  );
};

export default TextArea;
